import { Link } from 'react-router-dom';
import HERO_IMAGES from '../heroImages';
import SEO from '../components/SEO/SEO';
import { CheckCircle2, XCircle, ArrowRight } from 'lucide-react';
import pricing from '../data/pricing.json';
import './PricingPage.css';

export default function PricingPage() {
  return (
    <main className="pricing-page">
      <SEO
        title="Pricing — Simple, Fixed Project Pricing"
        description="Transparent, fixed pricing for web development, app development, automation, digital marketing, and cyber security consulting projects. No hidden fees — get a custom quote."
        path="/pricing"
        keywords="web development pricing India, app development cost, cyber security consulting pricing"
      />
      <section className="page-hero" style={{ backgroundImage: `url(${HERO_IMAGES.pricing})` }}>
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <span className="section-label">Transparent Pricing</span>
          <h1>
            Simple, Fixed
            <br />
            <span className="gradient-text">Project Pricing</span>
          </h1>
          <p>
            No hidden fees, no surprises. Choose a plan that fits your project
            or contact us for a custom quote.
          </p>
        </div>
      </section>

      <section style={{ padding: '80px 0', background: '#fff' }}>
        <div className="container">
          <div className="pricing-grid">
            {pricing.map((plan) => {
              // Detect custom-priced plans (Enterprise, etc.)
              const isCustom =
                plan.custom === true ||
                plan.price === 0 ||
                plan.price === null ||
                plan.price === undefined;

              return (
                <div
                  key={plan.id}
                  className={`pricing-card ${plan.popular ? 'pricing-card--popular' : ''} ${
                    isCustom ? 'pricing-card--custom' : ''
                  }`}
                >
                  {plan.popular && (
                    <div className="pricing-popular-badge">Most Popular</div>
                  )}
                  <div
                    className="pricing-plan-name"
                    style={{ color: plan.color }}
                  >
                    {plan.name}
                  </div>
                  <div className="pricing-plan-tagline">{plan.tagline}</div>

                  <div className="pricing-price">
                    {isCustom ? (
                      <>
                        <strong className="pricing-price--custom">Custom</strong>
                        <span>tailored to your needs</span>
                      </>
                    ) : (
                      <>
                        <strong>
                          {plan.currency}
                          {plan.price.toLocaleString('en-IN')}
                        </strong>
                        <span>/ {plan.period}</span>
                      </>
                    )}
                  </div>

                  <div className="pricing-divider" />
                  <div className="pricing-features">
                    {plan.features.map((f, i) => (
                      <div key={i} className="pricing-feature">
                        <CheckCircle2 size={16} color={plan.color} />
                        <span>{f}</span>
                      </div>
                    ))}
                    {plan.notIncluded.map((f, i) => (
                      <div key={i} className="pricing-feature pricing-feature--no">
                        <XCircle size={16} color="#CBD5E1" />
                        <span>{f}</span>
                      </div>
                    ))}
                  </div>

                  {isCustom ? (
                    <Link to="/contact" className="btn-primary">
                      Contact Us <ArrowRight size={15} />
                    </Link>
                  ) : (
                    <Link
                      to="/contact"
                      className={plan.popular ? 'btn-primary' : 'btn-ghost'}
                    >
                      Get Started <ArrowRight size={15} />
                    </Link>
                  )}
                </div>
              );
            })}
          </div>
          <p className="pricing-note">
            Need something custom? <Link to="/contact">Contact us</Link> for a
            tailored quote.
          </p>
        </div>
      </section>

      <section className="cta-strip">
        <div className="container">
          <div className="cta-strip-inner">
            <div className="cta-strip-text">
              <h2>Not Sure Which Plan Fits?</h2>
              <p>
                Book a free consultation and we'll recommend the best solution
                for your needs.
              </p>
            </div>
            <div className="cta-strip-actions">
              <Link to="/contact" className="btn-primary">
                Book Free Call <ArrowRight size={16} />
              </Link>
              <Link to="/services" className="btn-ghost">
                Explore Services
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}